(() => {
  'use strict';
  if (customElements.get('oestervang-gate-designer')) return;
  const ns = 'http://www.w3.org/2000/svg';
  const node = (tag, attrs = {}, text) => {
    const element = document.createElementNS(ns, tag);
    for (const [key, value] of Object.entries(attrs)) element.setAttribute(key, String(value));
    if (text !== undefined) element.textContent = text;
    return element;
  };

  // Reusable elevations of the three supplied fittings, in local coordinates.
  // The same geometry is used on the gate and in the enlarged detail.
  function drawHardware(parent, kind, frameHeight = 300) {
    const add = (tag, attrs, text) => {
      const element = node(tag, attrs, text); parent.append(element); return element;
    };
    const steel = '#bac2c4', edge = '#364348', bright = '#e5e9e7';
    if (kind === 'key') {
      add('rect', {x:-39,y:-49,width:40,height:97,rx:2,fill:'none',stroke:edge,'stroke-width':4});
      add('path', {d:'M-33 -38 Q-16 -43 -3 -36 V32 Q-18 40 -33 33 Z',fill:steel,stroke:edge,'stroke-width':2});
      add('path', {d:'M-30 -34 Q-18 -38 -7 -33',fill:'none',stroke:bright,'stroke-width':2});
      for (const y of [-28,26]) add('circle',{cx:-28,cy:y,r:1.6,fill:edge});
      add('circle',{cx:-18,cy:-13,r:8,fill:'#9ba8ab',stroke:edge,'stroke-width':1.5});
      add('path',{d:'M-18 -13 Q-34 0 -62 -7 L-72 -11',fill:'none',stroke:edge,'stroke-width':8,'stroke-linecap':'round'});
      add('path',{d:'M-18 -14 Q-34 -2 -62 -9 L-71 -12',fill:'none',stroke:bright,'stroke-width':4,'stroke-linecap':'round'});
      add('rect',{x:-23,y:7,width:12,height:19,rx:6,fill:'#dce2df',stroke:edge,'stroke-width':1.5});
      add('circle',{cx:-17,cy:13,r:3,fill:edge});
      add('path',{d:'M-18.5 14 L-20 21 H-14 L-15.5 14 Z',fill:edge});
      add('path',{d:'M1 -12 H24 V-4 H1',fill:steel,stroke:edge,'stroke-width':1.5});
      add('rect',{x:21,y:-18,width:7,height:30,rx:1,fill:'#a2adae',stroke:edge,'stroke-width':1.5});
    } else if (kind === 'spring') {
      // The reference uses the long rod itself as the spring, with no coil.
      // Origin: top of the closing stile. The foot stays at the bottom rail.
      const extension = Math.min(52, frameHeight * .17);
      const catchY = frameHeight * .04, guideY = frameHeight * .11;
      add('rect',{'data-og-part':'spring-strike-mount',x:15,y:catchY-8,width:5,height:17,rx:1,fill:steel,stroke:edge,'stroke-width':1.2});
      add('path',{'data-og-part':'spring-strike',d:`M19 ${catchY-6} H12 L5 ${catchY+1} V${catchY+6} H17 L20 ${catchY+3} Z`,fill:steel,stroke:edge,'stroke-width':1.2,'stroke-linejoin':'round'});
      add('path',{d:`M9 ${catchY+1} H14 V${catchY+4} H9`,fill:'#485558',stroke:edge,'stroke-width':.7});
      add('circle',{cx:17,cy:catchY-4,r:1.4,fill:bright,stroke:edge,'stroke-width':.7});
      const rod = `M10 ${-extension+5} C10 ${frameHeight*.25} 9 ${frameHeight*.62} 6 ${frameHeight-5}`;
      add('path',{'data-og-part':'spring-rod',d:rod,fill:'none',stroke:'#394547','stroke-width':3.5,'stroke-linecap':'round'});
      add('path',{d:rod,fill:'none',stroke:'#899697','stroke-width':1,'stroke-linecap':'round'});
      add('circle',{'data-og-part':'spring-knob',cx:10,cy:-extension,r:6.8,fill:'#202728',stroke:'#161c1d','stroke-width':1});
      add('path',{d:`M6.3 ${-extension-2} Q7.5 ${-extension-5.5} 10 ${-extension-4.8}`,fill:'none',stroke:'#707c7d','stroke-width':1.4,'stroke-linecap':'round'});
      add('path',{'data-og-part':'spring-guide',d:`M-4 ${guideY-3} H10 Q14 ${guideY-3} 14 ${guideY} V${guideY+4} H-4 Z`,fill:steel,stroke:edge,'stroke-width':1.2});
      add('path',{d:`M-3 ${guideY-1.5} H9`,fill:'none',stroke:bright,'stroke-width':1});
      add('path',{'data-og-part':'spring-foot',d:`M-2 ${frameHeight-8} L8 ${frameHeight-7} V${frameHeight-3} H-2 Z`,fill:steel,stroke:edge,'stroke-width':1});
    } else if (kind === 'hasp') {
      add('rect',{x:-78,y:-14,width:31,height:29,rx:3,fill:'#a5b0b1',stroke:edge,'stroke-width':1.6});
      add('rect',{x:42,y:-14,width:31,height:29,rx:3,fill:'#a5b0b1',stroke:edge,'stroke-width':1.6});
      add('path',{d:'M-75 -6 Q-77 -13 -68 -13 H57 Q73 -13 74 -2 Q74 10 58 11 H-68 Q-77 11 -75 -6 Z',fill:steel,stroke:edge,'stroke-width':2});
      add('path',{d:'M-65 -9 H55',fill:'none',stroke:bright,'stroke-width':2});
      add('circle',{cx:58,cy:-1,r:8,fill:'#98a7aa',stroke:edge,'stroke-width':2});
      add('path',{d:'M54 -5 L62 3 M62 -5 L54 3',stroke:bright,'stroke-width':1.6});
      add('rect',{x:-64,y:-24,width:7,height:24,rx:2,fill:steel,stroke:edge,'stroke-width':1.5});
      add('circle',{cx:-60.5,cy:-30,r:11,fill:'#728184',stroke:edge,'stroke-width':2});
      add('path',{d:'M-66 -34 Q-61 -39 -56 -34',fill:'none',stroke:bright,'stroke-width':2});
    }
  }

  class OestervangGateDesigner extends HTMLElement {
    connectedCallback() {
      this.ogController?.abort();
      this.ogController = new AbortController();
      const options = {signal:this.ogController.signal};
      this.isSharedSketch = new URL(location.href).searchParams.has('og_skitse');
      this.sketchVersion = 3;
      this.removeAttribute('data-og-shared');
      this.removeAttribute('data-og-share-error');
      for (const notice of this.querySelectorAll('[data-og="share-notice"],[data-og="share-error"]')) notice.hidden = true;
      // Keep the mobile sketch compact; choices never reset this disclosure.
      const compactPreview = window.matchMedia?.('(max-width: 650px)');
      const previewDetails = this.querySelector('[data-og="preview-details"]');
      if (compactPreview && previewDetails) {
        const resizePreview = () => { previewDetails.open = this.isSharedSketch || !compactPreview.matches; };
        resizePreview();
        compactPreview.addEventListener('change', resizePreview, options);
      }
      if (this.isSharedSketch) {
        const shared = this.readSharedConfiguration();
        if (!shared) {
          this.setAttribute('data-og-share-error','');
          const error = this.querySelector('[data-og="share-error"]');
          if (error) error.hidden = false;
          return;
        }
        this.sketchVersion = shared.version;
        this.applyConfiguration(shared);
        this.setAttribute('data-og-shared','');
        const notice = this.querySelector('[data-og="share-notice"]');
        if (notice) notice.hidden = false;
        const description = this.querySelector('[data-og="share-description"]');
        if (description) description.textContent = this.sketchVersion < 3
          ? 'Denne skitse er fra en tidligere forespørgsel. Bredden viser lågen uden stolper, som angivet på tidspunktet for forespørgslen.'
          : 'Her vises skitsen med de mål og tilvalg, der følger med linket. Totalbredden er inklusive begge stolper.';
        if (previewDetails) previewDetails.open = true;
      } else {
        this.restoreConfiguration();
      }
      this.addEventListener('input', event => {
        if (event.target.matches('[data-og="width"]')) {
          const notice = this.querySelector('[data-og="width-notice"]');
          if (notice) notice.hidden = true;
        }
        if (event.target.matches('[data-og="width"],[data-og="height"],[data-og="colour"]')) this.render();
      }, options);
      this.addEventListener('change', event => {
        if (!event.target.matches('input[data-og]')) return;
        this.enforceLockEligibility(['gate','top'].includes(event.target.dataset.og));
        this.render();
      }, options);
      this.addEventListener('submit', event => {
        if (this.isSharedSketch) { event.preventDefault(); return; }
        this.render(); this.saveConfiguration();
      }, options);
      this.render();
    }
    disconnectedCallback() { this.ogController?.abort(); }
    selected(group) { return this.querySelector(`input[data-og="${group}"]:checked`); }
    storageKey() { return `oestervang-gate:${location.pathname}:${this.id}`; }

    configuration() {
      const state = {};
      for (const group of ['gate','bar','lock','top','paint']) state[group] = this.selected(group)?.dataset.code;
      for (const name of ['width','height']) state[name] = this.querySelector(`input[data-og="${name}"]`)?.value || '';
      state.colour = state.paint === 'yes' ? this.querySelector('input[data-og="colour"]')?.value.slice(0,120) || '' : '';
      return state;
    }

    updateSketchLink() {
      const field = this.querySelector('[data-og="sketch-link"]');
      if (!field) return;
      // Only gate specifications are shared. Customer details stay in the email.
      const url = new URL(this.dataset.sharePath || '/', this.dataset.shareOrigin || location.origin);
      url.search = '';
      url.searchParams.set('og_skitse',String(this.sketchVersion));
      for (const [key,value] of Object.entries(this.configuration())) url.searchParams.set(`og_${key}`,value);
      url.hash = 'oestervang-designer';
      field.value = url.href;
      field.disabled = false;
      const note = this.querySelector('[data-og="sketch-mail-note"]');
      if (note) note.hidden = false;
    }

    readSharedConfiguration() {
      const params = new URL(location.href).searchParams;
      if (params.getAll('og_skitse').length !== 1 || !['1','2','3'].includes(params.get('og_skitse'))) return null;
      const state = {version:Number(params.get('og_skitse'))};
      for (const group of ['gate','bar','lock','top','paint']) {
        const values = params.getAll(`og_${group}`);
        if (values.length !== 1 || !Array.from(this.querySelectorAll(`input[data-og="${group}"]`)).some(input => input.dataset.code === values[0])) return null;
        state[group] = values[0];
      }
      if ((state.lock === 'spring' && state.gate !== 'single') || (state.lock === 'hasp' && state.gate !== 'double')) return null;
      if (state.version >= 2 && state.gate === 'double' && ['arched','arched-opening'].includes(state.top) && state.lock !== 'key') return null;
      for (const name of ['width','height']) {
        const values = params.getAll(`og_${name}`);
        if (values.length !== 1 || !/^(?:[1-9][0-9]*)?$/.test(values[0]) || (values[0] && !Number.isFinite(Number(values[0])))) return null;
        state[name] = values[0];
      }
      const colours = params.getAll('og_colour');
      if (colours.length !== 1 || colours[0].length > 120) return null;
      state.colour = state.paint === 'yes' ? colours[0] : '';
      return state;
    }

    applyConfiguration(state) {
      for (const group of ['gate','bar','lock','top','paint']) {
        const input = Array.from(this.querySelectorAll(`input[data-og="${group}"]`)).find(el => el.dataset.code === state[group]);
        if (input) input.checked = true;
      }
      for (const name of ['width','height']) {
        if (typeof state[name] === 'string' && /^(?:[1-9][0-9]*)?$/.test(state[name])) this.querySelector(`input[data-og="${name}"]`).value = state[name];
      }
      const colour = this.querySelector('input[data-og="colour"]');
      if (colour) colour.value = state.paint === 'yes' && typeof state.colour === 'string' ? state.colour.slice(0,120) : '';
    }

    enforceLockEligibility(announce = false) {
      const hasp = this.querySelector('input[data-og="lock"][data-code="hasp"]');
      const spring = this.querySelector('input[data-og="lock"][data-code="spring"]');
      const key = this.querySelector('input[data-og="lock"][data-code="key"]');
      const notice = this.querySelector('[data-og="lock-notice"]');
      if (!hasp || !spring || !key) return;
      const isDouble = this.selected('gate')?.dataset.code === 'double';
      // Preserve old emailed sketches; the current designer uses the new rules.
      const legacySharedSketch = this.isSharedSketch && this.sketchVersion === 1;
      const archedDouble = isDouble && ['arched','arched-opening'].includes(this.selected('top')?.dataset.code) && !legacySharedSketch;
      hasp.disabled = !isDouble || archedDouble;
      spring.disabled = isDouble;
      const invalidHasp = hasp.disabled && hasp.checked;
      const invalidSpring = spring.disabled && spring.checked;
      if (invalidHasp || invalidSpring) {
        key.checked = true;
        if (notice) {
          notice.hidden = false;
          const reason = archedDouble ? 'Dobbeltlåger med bue kan kun vælges med låsekasse.' : invalidSpring ? 'Fjederstangslås kan kun vælges til en enkeltlåge.' : 'Overfald kan kun vælges til en dobbeltlåge uden bue.';
          notice.textContent = reason + ' Låsevalget er ændret til låsekasse med nøgle og håndtag.';
        }
      } else if (announce && notice) {
        notice.textContent = ''; notice.hidden = true;
      }
    }

    saveConfiguration() {
      const state = {savedAt:Date.now(),version:this.sketchVersion,...this.configuration()};
      try { sessionStorage.setItem(this.storageKey(), JSON.stringify(state)); } catch (_) { /* Keep native form usable. */ }
    }
    restoreConfiguration() {
      try {
        const key = this.storageKey();
        if (this.querySelector('.og-status')) {sessionStorage.removeItem(key); return;}
        const raw = sessionStorage.getItem(key);
        if (!raw) return;
        const state = JSON.parse(raw);
        if (!state || !Number.isFinite(state.savedAt) || Date.now()-state.savedAt > 3600000) {sessionStorage.removeItem(key); return;}
        // Older drafts measured the gate without posts. Do not silently reuse
        // that width as a new outside-to-outside measurement.
        const oldWidth = state.version !== 3 && Boolean(state.width);
        this.applyConfiguration(oldWidth ? {...state,width:''} : state);
        const notice = this.querySelector('[data-og="width-notice"]');
        if (notice) notice.hidden = !oldWidth;
      } catch (_) { /* Keep the ordinary form usable without session storage. */ }
    }
    measurement(name) {
      const input = this.querySelector(`input[data-og="${name}"]`);
      const number = input?.value && /^[1-9][0-9]*$/.test(input.value) ? Number(input.value) : null;
      return input && input.validity.valid && Number.isFinite(number) && number > 0 ? number : null;
    }

    renderLockDetail(lock) {
      const panel = this.querySelector('[data-og="lock-detail-panel"]');
      const drawing = this.querySelector('[data-og="lock-detail"]');
      if (!panel || !drawing) return;
      const svg = node('svg',{viewBox:'0 0 360 210',role:'img','aria-label':`Forstørret, vejledende tegning af ${lock.value.toLowerCase()}`});
      const support = (tag,attrs) => svg.append(node(tag,attrs));
      const metal = {fill:'#d6dcda',stroke:'#7d8a8d','stroke-width':2};
      let transform;
      if (lock.dataset.code === 'hasp') {
        support('rect',{x:30,y:102,width:140,height:18,...metal});
        support('rect',{x:190,y:102,width:140,height:18,...metal});
        support('rect',{x:157,y:104,width:13,height:90,...metal});
        support('rect',{x:190,y:104,width:13,height:90,...metal});
        transform = 'translate(180 106) scale(1.7)';
      } else if (lock.dataset.code === 'spring') {
        svg.setAttribute('viewBox','0 0 360 400');
        support('rect',{x:28,y:70,width:156,height:8,...metal});
        support('rect',{x:176,y:74,width:8,height:300,...metal});
        support('rect',{x:28,y:370,width:156,height:8,...metal});
        for (const x of [68,119]) support('rect',{x,y:78,width:3.5,height:292,...metal,'stroke-width':1});
        support('rect',{x:195,y:67,width:16,height:320,rx:1,...metal});
        transform = 'translate(180 74)';
      } else {
        support('rect',{x:205,y:18,width:15,height:175,...metal});
        support('rect',{x:250,y:18,width:15,height:175,...metal});
        support('rect',{x:53,y:33,width:155,height:14,...metal});
        transform = 'translate(210 112) scale(1.4)';
      }
      const fitting = node('g',{transform,'data-og-hardware':lock.dataset.code});
      drawHardware(fitting,lock.dataset.code); svg.append(fitting);
      drawing.replaceChildren(svg);
      drawing.dataset.lock = lock.dataset.code;
      this.querySelector('[data-og="lock-title"]').textContent = lock.value;
      for (const img of this.querySelectorAll('[data-og-lock-photo]')) img.hidden = img.dataset.ogLockPhoto !== lock.dataset.code;
      panel.hidden = false;
    }

    render() {
      this.enforceLockEligibility();
      const target = this.querySelector('[data-og="drawing"]');
      const summary = this.querySelector('[data-og="summary"]');
      const gate = this.selected('gate'), bar = this.selected('bar'), lock = this.selected('lock'), top = this.selected('top'), paint = this.selected('paint');
      if (!target || !summary || !gate || !bar || !lock || !top || !paint) return;
      const isDouble = gate.dataset.code === 'double';
      const painted = paint.dataset.code === 'yes';
      const colour = this.querySelector('input[data-og="colour"]');
      const colourField = this.querySelector('[data-og="colour-field"]');
      if (colour) colour.disabled = !painted;
      if (colourField) colourField.hidden = !painted;
      const width = this.measurement('width'), height = this.measurement('height');
      const format = n => n === null ? 'Aftales med mig' : `${new Intl.NumberFormat('da-DK').format(n)} mm`;
      const includesPosts = this.sketchVersion >= 3;
      const topLabel = this.sketchVersion === 1 && top.dataset.code === 'arched-opening' ? 'Vandret åbning med buet/valset topprofil' : top.value;
      const rows = [['Lågetype',gate.value],[includesPosts?'Totalbredde inkl. 2 stolper':'Samlet bredde',format(width)],['Højde',format(height)],['Tremmer',bar.value],['Lås',lock.value],['Top',topLabel],['Galvanisering','Varmgalvanisering – altid inkluderet'],['Maling',painted?'Ja – efter varmgalvanisering':'Nej']];
      if (painted) rows.push(['Farveønske',colour?.value.trim() || 'Aftales med mig']);
      summary.replaceChildren();
      for (const [label,value] of rows) {
        const row = document.createElement('div'); row.className = 'og-summary-row';
        const key = document.createElement('span'); key.textContent = label;
        const answer = document.createElement('strong'); answer.textContent = value;
        row.append(key,answer); summary.append(row);
      }
      this.querySelector('[data-og="drawing-title"]').textContent = isDouble ? 'DIN DOBBELTLÅGE' : 'DIN ENKELTLÅGE';

      // Equal leaves and fixed illustrative bar counts, not fabrication dimensions.
      const ratio = width && height ? Math.max(.5,Math.min(2.1,width/height)) : (isDouble?1.7:1);
      // In v3, entered width controls the span including both illustrative posts
      // and the gaps. Post/profile sizes are agreed separately with the customer.
      const totalRatio = includesPosts && width && height;
      const outsideAllowance = 64;
      const maxSpan = (isDouble?460:400) + (totalRatio?outsideAllowance:0);
      const w = Math.min(maxSpan,300*ratio) - (totalRatio?outsideAllowance:0), h = Math.min(300,maxSpan/ratio);
      const x = (640-w)/2, right = x+w, bottom = 376, y = bottom-h;
      const arched = ['arched','arched-opening'].includes(top.dataset.code);
      const opening = ['opening','arched-opening'].includes(top.dataset.code);
      const curvedOpening = arched && opening && this.sketchVersion >= 2;
      const rise = arched?h*.16:0, shoulder = y+rise;
      const band = shoulder+(bottom-shoulder)*.2;
      const frame = 8, gap = 14;
      const topAt = px => shoulder-4*rise*((px-x)/w)*(1-(px-x)/w);
      const openingGap = (bottom-shoulder)*.2;
      const innerAt = px => topAt(px)+openingGap;
      const leaves = isDouble ? [[x,320-gap/2],[320+gap/2,right]] : [[x,right]];
      const svg = node('svg',{viewBox:'0 0 640 480',role:'img','aria-label':`Vejledende skitse af ${gate.value.toLowerCase()} med lodrette tremmer, ${bar.value}, ${topLabel} og ${lock.value}.`});
      const add = (tag,attrs,text) => {const element=node(tag,attrs,text);svg.append(element);return element;};
      for (let gx=40;gx<640;gx+=40) add('line',{x1:gx,y1:25,x2:gx,y2:450,stroke:'#dedcd6','stroke-width':.6});
      for (let gy=40;gy<460;gy+=40) add('line',{x1:25,y1:gy,x2:615,y2:gy,stroke:'#dedcd6','stroke-width':.6});
      add('line',{x1:65,y1:bottom+12,x2:575,y2:bottom+12,stroke:'#c9c7c0','stroke-width':1});
      for (const postX of [x-31,right+15]) add('rect',{x:postX,y:shoulder-7,width:16,height:bottom-shoulder+20,rx:1,fill:'#a7b0b0',stroke:'#566367','stroke-width':2});
      for (const [a,b] of leaves) {
        const bars = isDouble?6:11;
        for (let i=1;i<=bars;i++) {
          const bx = a+(b-a)*i/(bars+1);
          add('line',{'data-og-part':'bar',x1:bx,y1:(curvedOpening?innerAt(bx):opening?band:topAt(bx))+frame/2,x2:bx,y2:bottom-frame/2,stroke:'#292e31','stroke-width':bar.dataset.code.endsWith('12')?4.3:3.6,'stroke-linecap':bar.dataset.code.startsWith('round')?'round':'butt'});
        }
        const mid=(a+b)/2, control=2*topAt(mid)-(topAt(a)+topAt(b))/2;
        const upper = arched?`Q${mid} ${control} ${b} ${topAt(b)}`:`H${b}`;
        add('path',{'data-og-part':'leaf',d:`M${a} ${bottom}V${topAt(a)}${upper}V${bottom}Z`,fill:'none',stroke:'#252a2d','stroke-width':frame,'stroke-linejoin':'round'});
        if (curvedOpening) add('path',{'data-og-part':'opening-rail',d:`M${a} ${innerAt(a)}Q${mid} ${control+openingGap} ${b} ${innerAt(b)}`,fill:'none',stroke:'#252a2d','stroke-width':frame});
        else if (opening) add('line',{'data-og-part':'opening-rail',x1:a,y1:band,x2:b,y2:band,stroke:'#252a2d','stroke-width':frame});
      }
      for (const side of isDouble?['left','right']:['left']) {
        const hingeX = side==='left'?x-16:right-2;
        for (const hy of [shoulder+35,bottom-35]) add('rect',{x:hingeX,y:hy,width:18,height:12,rx:2,fill:'#aeb8b9',stroke:'#37474a','stroke-width':2});
      }
      const closeX=isDouble?320-gap/2:right;
      let transform;
      if (lock.dataset.code==='hasp') transform=`translate(320 ${topAt(320)}) scale(.7)`;
      else if (lock.dataset.code==='spring') transform=`translate(${closeX} ${topAt(closeX)})`;
      else transform=`translate(${closeX} ${topAt(closeX)+(bottom-topAt(closeX))*.5}) scale(.64)`;
      const fitting=node('g',{transform,'data-og-hardware':lock.dataset.code});
      drawHardware(fitting,lock.dataset.code,bottom-topAt(closeX)); svg.append(fitting);
      const measureLeft = includesPosts?x-32:x, measureRight = includesPosts?right+32:right;
      add('line',{x1:measureLeft,y1:bottom+40,x2:measureRight,y2:bottom+40,stroke:'#969b98','stroke-width':1});
      for (const tickX of [measureLeft,measureRight]) add('line',{x1:tickX,y1:bottom+34,x2:tickX,y2:bottom+46,stroke:'#969b98','stroke-width':1});
      add('text',{x:320,y:bottom+64,'text-anchor':'middle',fill:'#586161','font-size':12,'font-family':'Arial, sans-serif'},width===null?(includesPosts?'Totalbredde aftales':'Samlet bredde aftales'):format(width));
      if (includesPosts) add('text',{x:320,y:bottom+80,'text-anchor':'middle',fill:'#586161','font-size':11,'font-family':'Arial, sans-serif'},'Inkl. 2 stolper · yderkant til yderkant');
      const hx=x-45, mid=(y+bottom)/2;
      add('line',{x1:hx,y1:y,x2:hx,y2:bottom,stroke:'#969b98','stroke-width':1});
      for (const tickY of [y,bottom]) add('line',{x1:hx-6,y1:tickY,x2:hx+6,y2:tickY,stroke:'#969b98','stroke-width':1});
      add('text',{x:hx-11,y:mid,'text-anchor':'middle',transform:`rotate(-90 ${hx-11} ${mid})`,fill:'#586161','font-size':12,'font-family':'Arial, sans-serif'},height===null?'Højde aftales':format(height));
      target.replaceChildren(svg);
      this.renderLockDetail(lock);
      this.updateSketchLink();
    }
  }
  customElements.define('oestervang-gate-designer',OestervangGateDesigner);
})();
